import { start } from '@jutro/app';
import _ from 'lodash';
import {
    BrowserRouter
} from 'react-router-dom';
import { initDefaultGA } from '@jutro/events';
import  { BrandingService } from '@xengage/gw-portals-branding-js'
import { LocaleService, G11nstore } from 'gw-portals-i18n-react';
import 'regenerator-runtime';
import appConfig from 'app-config';
import { Loader } from '@jutro/components';
import style from './app/App.scss'

import App from './app/App';

import { configureLegacyComponentMap } from '@jutro/legacy/uiconfig';
configureLegacyComponentMap();

export const startApp = (scriptAttributes) => {

    const silentRedirectPath = appConfig?.authentication?.servers?.okta?.JUTRO_AUTH_SILENT_REDIRECT_PATH;
    const silentLoginPath = appConfig?.authentication?.servers?.okta?.JUTRO_AUTH_SILENT_LOGIN_PATH;

    if (window.self === window.top) { 
        const theBody = document.getElementsByTagName('body')[0];

        theBody.style.display = 'block';
    } else if ((!silentLoginPath || !window.self.location.pathname.endsWith(silentLoginPath)) && (!silentRedirectPath || !window.self.location.pathname.endsWith(silentRedirectPath))) { 
        const {host, protocol} = new URL(window.top.location)
        const root = `${protocol}//${host}`
        const rootPath = process.env.PUBLIC_PATH

        window.top.location = new URL(rootPath, root);
    }

    const { trackingConfig = {}, authentication = {}, microFrontendsConfig = {}, policyTransactionMicroAppConfig = {} } = appConfig;

    const gaTrackingId = trackingConfig.GA_TRACKING_ID;

    if (gaTrackingId) {
        initDefaultGA(trackingConfig);
    }

    function premierLoader() {
        const { env, applicationDetails } = appConfig;
        const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');
        const logo = `${prefix}/${applicationDetails.applicationLoader}`
        
        return (
            <div>
                <img src={logo} alt="Presto Logo - home page"/>
            </div>
        )
    }

    Loader.defaultProps = {
        renderLoader: premierLoader
    };

    const config = {
        ...authentication.servers.okta,
        ...policyTransactionMicroAppConfig,
        ...{microFrontendsConfig},
        ...appConfig.credentials
    };

    start(App, {
        rootId: 'root',
        themeConfig: BrandingService.getBrandingTheme(),
        messageLoader: LocaleService.loadMessages,
        coreMessageLoader: LocaleService.loadCoreMessages,
        refreshOnLanguageOrLocaleChange: true,
        routerBasename: '/producer-engage',
        config: [config],
        g11nStore: G11nstore(),

        onInit: () => {
            LocaleService.register();
        },

        Router: BrowserRouter,

        appName: {
            id: 'digital.appName',
            defaultMessage: 'ProducerEngage'
        },

        appDescription: 'ProducerEngage',
        mfeData: {scriptAttributes},
    });
};
